import { render, staticRenderFns } from "./Collate.vue?vue&type=template&id=bf313e36&"
import script from "./Collate.vue?vue&type=script&lang=js&"
export * from "./Collate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports